/**
 * Safely decode a URL, handling multiple encoding layers and edge cases
 */
export function decodeUrl(url: string): string {
  if (!url) return url;

  try {
    // Decode up to 3 times to handle double/triple encoding
    let decoded = url;
    for (let i = 0; i < 3; i++) {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break; // No more decoding needed
      decoded = next;
    }
    return decoded;
  } catch (e) {
    // If decoding fails (malformed URL), return original
    return url;
  }
}

/**
 * Get a human-readable path from a URL (decoded)
 */
export function getReadablePath(url: string): string {
  try {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname + parsedUrl.search;
    return decodeUrl(path);
  } catch (e) {
    // If URL parsing fails, try to decode the whole thing
    return decodeUrl(url);
  }
}

/**
 * Get a shortened, readable version of a URL
 */
export function getShortenedUrl(url: string, maxLength: number = 80): string {
  const readable = decodeUrl(url);
  if (readable.length <= maxLength) return readable;
  return readable.substring(0, maxLength - 1) + '…';
}
